import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

//components
import SwitchWidget from '../../Admin/ControlPanel/SwitchWidget.js';
import Button from '../../../components/CustomButton/CustomButton.jsx';

//utils
import { modulePermissionsMap } from '../../../utils/constants.js';
import { checkCircleSVG, crossCircleSVG, saveSVG, editSVG, backSVG } from '../../../utils/constants';

const RosterPermissionsTab = ({ t, modulePermissions, currentId, currentPermission, isNoDepartment, isMember, onEdit, onSave, onCancel, onPermissionChange, allowShiftAutoTimesheetToggle, allowUserAutoTimesheetToggle, isAutoScheduleMode }) => {
    const rosterModules = Object.keys(modulePermissionsMap).map(key => modulePermissions.find(ele => ele.module === key)).filter(Boolean);

    return (
        <div className="row mt-1">
            <div className="col-12 mb-2">
                {isNoDepartment ? (
                    <span className="font-size-11 text-muted">
                        <i className="fa fa-info-circle me-1"></i>
                        {t('Note')} : {t('Cannot change roster permissions for this user as there is no department.')}
                    </span>
                ) : (isMember && allowUserAutoTimesheetToggle) ? (
                    <div className="font-size-11 text-muted">
                        <i className="fa fa-info-circle me-1"></i>
                        {t('Note')} :
                        <ul className="mb-0 ps-4">
                            <li>{t('Some roster features require Roster View. It will be enabled automatically when needed.')}</li>
                            <li>{t("Changing the 'Edit Auto Time Recording' permission will grant or revoke access to auto time recording for members. It will also update the Schedule 'Create, Edit & Delete' permissions accordingly as suggested settings. These permissions can be modified as needed from below.")}</li>
                        </ul>
                    </div>
                ) : (
                    <span className="font-size-11 text-muted">
                        <i className="fa fa-info-circle me-1"></i>
                        {t('Note')} : {t('Some roster features require Roster View. It will be enabled automatically when needed.')}
                    </span>
                )}
            </div>
            {rosterModules.map((ele, index) => {
                const config = modulePermissionsMap[ele.module];
                const isEditing = currentId === ele.module;
                const colClass = rosterModules.length <= 2 ? 'col-md-6' : 'col-md-4';
                const displayedPerms = config.permissions.filter(perm => perm.value in ele.permissions
                    && !(ele.module === 'md_Shift' && perm.value === 'editAutoTimeRecording' && !allowShiftAutoTimesheetToggle)
                    && !(ele.module === 'md_Shift' && perm.value === 'manageFutureScheduleEntry' && !isAutoScheduleMode));
                return (
                    <div key={`roster_card_${index}`} className={`${colClass} mb-3 d-flex`}>
                        <div className="card h-100 w-100 shadow-sm">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <span className="fw-bold">{t(config.label)}</span>
                                <div>
                                    {isEditing ? (
                                        <>
                                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">{t('Update Permissions')}</Tooltip>}>
                                                <Button icon_sm fill onClick={onSave}>
                                                    {saveSVG({ width: 20, fillColor: '#2550AC' })}
                                                </Button>
                                            </OverlayTrigger>
                                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">{t('Cancel')}</Tooltip>}>
                                                <Button icon_sm fill ms2 onClick={onCancel}>
                                                    {backSVG({ width: 20, fillColor: '#2550AC' })}
                                                </Button>
                                            </OverlayTrigger>
                                        </>
                                    ) : (
                                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">{(isNoDepartment && ele.module !== 'md_Shift') ? t('Cannot change roster permissions for this user as there is no department.') : t('Change Permissions')}</Tooltip>}>
                                            <span className="d-inline-block">
                                                <Button icon_sm fill disabled={!!currentId || (isNoDepartment && ele.module !== 'md_Shift')} onClick={() => onEdit(ele.module, ele.permissions)}>
                                                    {editSVG({ width: 20, fillColor: '#2550AC' })}
                                                </Button>
                                            </span>
                                        </OverlayTrigger>
                                    )}
                                </div>
                            </div>
                            <div className="card-body">
                                {displayedPerms.map((perm, i) => (
                                    <div key={`perm_${i}`}>
                                        <div className="d-flex justify-content-between align-items-center py-1">
                                            <div className="d-flex align-items-center gap-1">
                                                <span className="font-size-12">{t(perm.label)}</span>
                                                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">{t(perm.description)}</Tooltip>}>
                                                    <i className="fa fa-info-circle text-muted opacity-50 font-size-12" aria-hidden="true"></i>
                                                </OverlayTrigger>
                                            </div>
                                            <div>
                                                {isEditing ? (
                                                    <SwitchWidget
                                                        value={currentPermission.permissions[perm.value]}
                                                        onChange={checked => onPermissionChange(perm.value, checked)}
                                                    />
                                                ) : (
                                                    ele.permissions[perm.value]
                                                        ? checkCircleSVG({ width: 16, fillColor: '#16C51D' })
                                                        : crossCircleSVG({ width: 18, fillColor: '#FF0000' })
                                                )}
                                            </div>
                                        </div>
                                        {i < displayedPerms.length - 1 && <hr className="my-1" />}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default RosterPermissionsTab;
